/// <amd-module name="Repos/Views/Import/Components/Clone/CloneWithApplication" />
import * as React from "react";

import { ObservableArray, ObservableValue } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";

import { IMenuItem } from "VSSUI/Menu";
import { Observer } from "VSSUI/Observer";
import { SplitButton } from "VSSUI/SplitButton";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { IGitProtocolHandlerService, IProtocolHandler } from "Repos/Views/Import/ProtocolHandler";

import * as Resources from "Repos/Views/Import/Resources";

import { CloneWithApplicationProps } from "./CloneWithApplication.Props";

export class CloneWithApplication extends VssComponent<CloneWithApplicationProps> {
    private cloneMenuItems = new ObservableArray<IMenuItem>();
    private protocolHandlers: ObservableArray<IProtocolHandler>;
    private selectedApplication = new ObservableValue<IProtocolHandler | undefined>(undefined);
    private supportedOS: string;

    constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        // Determine the OS we are on to filter the protocolHandler properly.
        if (navigator.platform.indexOf("Win") > -1) {
            this.supportedOS = "Win";
        } else if (navigator.userAgent.indexOf("Mac OS X") > -1) {
            this.supportedOS = "Mac";
        } else {
            this.supportedOS = "Linux";
        }

        // Load the protocol handlers used to initialize a repo for this project.
        const protocolHandlerService = context.pageContext.getService<IGitProtocolHandlerService>("IGitProtocolHandlerService");
        this.protocolHandlers = protocolHandlerService.getHandlers();

        // Process the initial handlers into menu items.
        this.processHandlers(this.protocolHandlers.value);
    }

    public render() {
        return (
            <Observer
                protocolHandlers={{
                    observableValue: this.protocolHandlers,
                    filter: (handlerChange: { addedItems: IProtocolHandler[] }) => this.processHandlers(handlerChange.addedItems)
                }}
                selectedApplication={this.selectedApplication}
            >
                {(props: { selectedApplication: IProtocolHandler | undefined }) =>
                    props.selectedApplication ? (
                        <>
                            {this.props.label ? <span className={this.props.labelClassName}>{this.props.label}</span> : null}
                            <div className="clone-with-application flex-row">
                                <SplitButton
                                    buttonProps={{
                                        onClick: () => window.open(this.selectedApplication.value!.protocolHandlerUrl, "_blank"),
                                        iconProps: { iconName: "CloneToDesktop" },
                                        text: format(Resources.CloneIn, props.selectedApplication.name)
                                    }}
                                    menuButtonProps={{
                                        contextualMenuProps: {
                                            menuProps: {
                                                id: "clone-button",
                                                items: this.cloneMenuItems,
                                                onActivate: (menuItem: IMenuItem) => {
                                                    this.selectedApplication.value = menuItem.data;
                                                }
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </>
                    ) : null
                }
            </Observer>
        );
    }

    private processHandlers(protocolHandlers: IProtocolHandler[]) {
        const cloneMenuItems: IMenuItem[] = [];
        protocolHandlers.forEach(handler => {
            if (this.selectedApplication.value === undefined) {
                this.selectedApplication.value = handler;
            } else if (handler.name === "VS Code") {
                this.selectedApplication.value = handler;
            }

            if (handler.supportedPlatforms.indexOf(this.supportedOS) >= 0) {
                cloneMenuItems.push({
                    data: handler,
                    href: handler.protocolHandlerUrl,
                    id: handler.name,
                    target: "_blank",
                    text: handler.name
                });
            }
        });

        // Update the clone menu items with the newly filtered handlers.
        this.cloneMenuItems.push(...cloneMenuItems);
    }
}
